import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Fido from '../utils/Fido';
import PaddedLayout from '../components/PaddedLayout';
import AuthorizedUser from "../utils/AuthorizedUser";

import {
	withStyles,
	Paper, Typography,
	Grid
} from '@material-ui/core';
import LoginCarousel from '../components/LoginCarousel';
import SignupForm from '../components/SignupForm';
import FormHelper from '../utils/FormHelper';

const styles = theme => ({
	paddedLayout: {
		width: "100%",
		height: "100%",
	},

	paper: {
		height: "100vh"
	},

	container: {
		margin: "300px 120px 20px 80px"
	},

	errorPaper: {
		padding: theme.spacing(1.5),
		marginBottom: theme.spacing(1)
	},

	longDialogTitle: {
		display: "none",

		[theme.breakpoints.up('sm')]: {
			display: "inline"
		}
	},

	icon: {
		fontSize: "1.5rem",
		marginRight: "0.3rem",
		color: theme.palette.secondary.slate
	},

	helpButton: {
		maxWidth: "100%",
		padding: theme.spacing(1),
		color: theme.palette.secondary.slate
	},

	// for some reason using Typography noWrap threw an error
	email: {
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis"
	},

	description: {
		paddingBottom: theme.spacing(1)
	},

	branding: {
		paddingBottom: theme.spacing(1)
	},
	heading: {
		fontSize: 18,
		fontWeight: 400,
	},

});

class Signup extends Component {
	constructor(props, context) {
		super(props, context);

		let formValues = Object.assign({});

		this.state = {
			timezones: ["America/New_York"],
			dataLoading: true,
			jobTitles: {},
			formValues: formValues,
			forgotPass: false,
			error: false,
			districts: [],
			successfulRegister: false,
		};

		this.fido = new Fido();
		this.sharedFido = new Fido();
		this.userTypesFido = new Fido();

		this.handleChange = this.handleChange.bind(this);
		this.handleRegisterSubmit = this.handleRegisterSubmit.bind(this);
		this.loadData = this.loadData.bind(this);
		this.fetchDistricts = this.fetchDistricts.bind(this);
	}

	componentDidMount() {
		this.loadData();
		document.body.classList.add("login");
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.authorized !== this.props.authorized) {
			// If authorized, don't require form submission
			this.handleRedirect('/', this.props.location.search);
		}
	}

	componentWillUnmount() {
		this.props.resetHeader();
		this.sharedFido.dropIt();
		this.userTypesFido.dropIt();
		document.body.classList.remove("login");
	}

	loadData() {
		let timeZoneFetch = this.sharedFido.fetch('/config/timezones'),
			promises = [timeZoneFetch];


		Promise.all(promises)
			.then(responses => {
				let update = {};
				if (responses[0].length > 0) {
					update.timezones = responses[0];
				}

				if (Object.keys(update).length) {
					this.setState(update);
				}
			})
			.catch(error => {
				console.warn(error);
				this.props.showSnackbar('Unexpected server response. Please try later.');
				return false;
			});
		this.setState({ dataLoading: false });
	}

	fetchDistricts(stateCode) {

		this.sharedFido.fetch(`/signup/districts/${stateCode}`, { cors: true })
			.then(response => {
				const result = response.map(val => ({
					id: val,
					name: val
				}));
				this.setState({ districts: result });
			})
			.catch(error => {
				console.error("Error fetching districts:", error);
				this.props.showSnackbar('Error fetching districts. Please try again.');
			});
	}

	handleChange(event) {
		// let formValues = this.state.formValues;
		// formValues[event.target.name] = event.target.value;
		let formValues = Object.assign(this.state.formValues, FormHelper.getChanged(event));

		if (event.target.name === 'state') {
			const selectedState = event.target.value;
			if (selectedState) {
				this.fetchDistricts(selectedState);
			} else {
				this.setState({ districts: [] });
			}
		}
		this.setState({ formValues: formValues });
	}

	handleRegisterSubmit(formValues) {
		if (!this.props.authorized) {
			let to = Fido.getSearchParam("to", this.props.location.search);

			const payload = {
				...formValues,
				role: 'admin',
				source: 'signup'				
			};


			this.setState({ error: false });
			this.fido.fetch('/signup', {
				cors: true,
				method: "POST",
				body: JSON.stringify(payload)
			})
				.then((data) => {
					if (data) {
						if (data && data.messages && data.messages.error && data.messages.error.length) {
							this.setState({ error: data.messages.error });
						} else {
							this.setState({ successfulRegister: true })							
						}
					}
				})
				.catch(error => this.props.showSnackbar(error.message));
		}
	}

	// Override "to" param if one sent in with url params; pass along rest
	handleRedirect = (to, params) => {
		let paramsObj = Fido.getSearchParamsObject(params);

		to = paramsObj.to || to;
		delete (paramsObj.to);

		let queries = Object.keys(paramsObj).map(k => `${k}=${paramsObj[k]}`).join('&'),
			url = `${to}${queries ? "?" + queries : ""}`;

		this.props.history.push(url);
	}

	render() {
		let { classes, history } = this.props,
			{ formValues, forgotPass, error, timezones, dataLoading, jobTitles, districts } = this.state;

		return (
			<PaddedLayout className={classes.paddedLayout}>
				{error ? <Paper className={classes.errorPaper}><Typography align="center" color="error">{error}</Typography></Paper> : null}
				<Paper className={classes.paper}>
					<Grid container justifyContent='center' style={{ height: "100vh" }}>
						<Grid item xs={12} md={6} justifyContent='center' alignItems='center'>
							{this.state.successfulRegister &&
								<div className={classes.container}>
									<Typography className={classes.heading}>Your account has been successfully created, please check your email to finish setup</Typography>
								</div>}
							{!this.state.successfulRegister &&
								<SignupForm
									dataLoading={dataLoading}
									formValues={formValues}
									timezones={timezones}
									jobTitles={jobTitles}
									allDistricts={districts}
									handleChange={this.handleChange}
									handleSubmit={this.handleRegisterSubmit} />
							}
						</Grid>
						<Grid item xs={12} md={6} justifyContent='center' style={{ background: '#3398A5', display: "flex", alignItems: "center" }}>
							<LoginCarousel />
						</Grid>
					</Grid>

				</Paper>
			</PaddedLayout>
		);
	}
}

Signup.propTypes = {
	classes: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
	resetHeader: PropTypes.func,
	updateHeader: PropTypes.func,
	showSnackbar: PropTypes.func,
	authorized: PropTypes.object,
	loginCallback: PropTypes.func.isRequired,
	loadUserFailed: PropTypes.func.isRequired
};

export default withStyles(styles)(withRouter(Signup));
